import React, { useEffect, useState } from 'react';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { Autocomplete } from '@material-ui/lab';
import Container from '@material-ui/core/Container';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import CenterList from './centerList';
import { useForm } from '../../hooks/useForm';
import api from '../../API/Api';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { useSnackBar } from '../../Context/Snackbar/withSnackbar';

function centerListSearch() {
  const { showSnackBar } = useSnackBar();

  const entryInput = {
    data: {
      categories: [
        { name: { en: '', es: '' }, options: [] },
        { name: { en: '', es: '' }, options: [] },
        {
          name: { en: '', es: '' },
          options: [
            {
              id: '',
              name: {
                en: '',
                es: '',
              },
            },
          ],
        },
      ],
      states: [],
      center_count: [],
    },
  };
  const [formFieldInfo, setformFieldInfo] = useState(entryInput);
  const [States, setStates] = useState(null);
  const [StatesCode, setStatesCode] = useState('');
  const [population, setPopulation] = useState([]);
  const [Provider, setProvider] = useState([]);
  const [populationCategoryId, setpopulationCategoryId] = useState([]);
  const [providerCategoryId, setproviderCategoryId] = useState([]);
  const categoryId = [...providerCategoryId, ...populationCategoryId];

  useEffect(() => {
    api.getFormData()
      .then((response: any) => {
        if (response.data && response.data.success) {
          setformFieldInfo(response.data);
        }
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          if (error.response.data.message) {
            showSnackBar(error.response.data.message, 'error');
          } else if (error.response.data.error) {
            showSnackBar(error.response.data.error, 'error');
          } else if (error.response.data.errors) {
            showSnackBar(error.response.data.errors.join("\n"), 'error');
          }
        } else {
          showSnackBar(error.message, 'error');
        }
      });
  }, []);

  const Initial = {
    centerName: '',
    zip: '',
  };
  const { Values, setValues, handleChange, resetForm } = useForm(Initial);
  const [exclude, setexclude] = useState(false);
  const [Clear, setClear] = useState(false);
  const [startDate, setStartDate] = useState<Date | null>(null);
  const searchInitial = {
    centerName: '',
    state: '',
    zip: 0,
    categoryId: [],
    endDate: '',
    startDate: '',
    exclude: false
  }
  const [searchData, setSearchData] = useState(searchInitial);

  const handleStartDate = (date: Date | null) => {
    setStartDate(date);
  };

  const [endDate, setEndDate] = useState<Date | null>(null);

  const handleEndDate = (date: Date | null) => {
    setEndDate(date);
  };
  const handleApply = () => {
    setSearchData({
      centerName: Values.centerName,
      state: StatesCode,
      zip: Values.zip | 0,
      categoryId: categoryId,
      endDate: endDate as any,
      startDate: startDate as any,
      exclude: exclude
    });
    setClear(true)
  };

  const handleClear = () => {
    setValues(Initial);
    setStartDate(null);
    setEndDate(null);
    setClear(false);
    setStates(null);
    setStatesCode('');
    setPopulation([]);
    setProvider([]);
    setpopulationCategoryId([]);
    setproviderCategoryId([]);
    setexclude(false);
    setSearchData(searchInitial);
  };

  const handleApplyClick =()=>{
    setClear(false)
  }
  return (
    <>
      <Container>
        <Typography
          component="div"
          className="rainn-lg-container centers-admin-panel"
        >
          <Typography
            component="div"
            className="flex justify-between items-center py-5 border-b border-tc-6 mb-3"
          >
            <Typography component="h1" className="centers-admin-section-text">
              Center List
            </Typography>
            <Link to="/center_list_add" className="button-primary">Add Center</Link>
          </Typography>
          <Grid container spacing={3} className="bg-tc-7 w-full m-0">
            <Grid item md={4} xs={12}>
              <TextField
                className="centers-admin-input"
                label="Search Center Name"
                name="centerName"
                value={Values.centerName}
                onChange={handleChange}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Autocomplete
                disableClearable
                clearOnEscape
                options={formFieldInfo?.data.states}
                getOptionLabel={(option: any) => {
                  return option.name;
                }}
                openOnFocus
                value={States}
                onChange={(event, newValue) => {
                  if (newValue) {
                    setStatesCode(newValue.code);
                  }
                  setStates(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="centers-admin-autocomplete"
                    label="Select state"
                  />
                )}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <TextField
                type="number"
                className="centers-admin-input"
                label="Add Zip Code"
                name="zip"
                value={Values.zip}
                onChange={handleChange}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Autocomplete
                multiple
                limitTags={2}
                id="population"
                options={formFieldInfo.data.categories[1].options}
                getOptionLabel={(option) => option.name?.en}
                value={population}
                onChange={(event, newInput) => {
                  if (newInput !== null) {
                    setpopulationCategoryId(
                      JSON.parse(JSON.stringify(newInput)).map(
                        (doc: { id: string }) => doc.id
                      )
                    );
                    setPopulation(newInput as any);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="centers-admin-autocomplete"
                    label={`${formFieldInfo.data.categories[1].name.en}`}
                  />
                )}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Autocomplete
                multiple
                limitTags={2}
                id="provider"
                options={formFieldInfo.data.categories[0].options}
                getOptionLabel={(option) => option.name?.en}
                value={Provider}
                onChange={(event, newInput) => {
                  if (newInput !== null) {
                    setproviderCategoryId(
                      JSON.parse(JSON.stringify(newInput)).map(
                        (doc: { id: string }) => doc.id
                      )
                    );
                    setProvider(newInput as any);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    className="centers-admin-autocomplete"
                    label={`${formFieldInfo.data.categories[0].name.en}`}
                  />
                )}
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  format="MM/dd/yyyy"
                  margin="normal"
                  clearable
                  id="start-date-picker"
                  label="Last Updated Date (Start Date)"
                  value={startDate}
                  onChange={date => handleStartDate(date)}
                  className="centers-admin-date-picker"
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item md={4} xs={12}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                  format="MM/dd/yyyy"
                  clearable
                  margin="normal"
                  id="end-date-picker"
                  label="Last Updated Date (End Date)"
                  value={endDate}
                  onChange={handleEndDate}
                  className="centers-admin-date-picker"
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item md={4} xs={12}>
              <FormControl component="fieldset">
                <FormControlLabel
                  className="centers-admin-checkbox mt-2"
                  control={
                    <Checkbox
                      name="exclude"
                      color="primary"
                      checked={exclude}
                      onChange={(e: any) => {
                        setexclude(e.target.checked);
                      }}
                    />
                  }
                  label="Exclude"
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} className="flex justify-end">
              <Button className="button-primary mr-3" onClick={handleApply}>
                Apply
              </Button>
              <Button className="button-transparent" onClick={handleClear}>
                Clear
              </Button>
            </Grid>
          </Grid>
        </Typography>
        <CenterList
          centerName={searchData.centerName}
          state={searchData.state}
          zip={searchData.zip}
          categoryIds={searchData.categoryId}
          endDate={searchData.endDate}
          startDate={searchData.startDate}
          exclude={searchData.exclude}
          click={handleApplyClick}
          Clear= {Clear}
        />
      </Container>
    </>
  );
}
export default centerListSearch;
